<template>
  <div>
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <div class="el-form-group_isRound">
          <el-form
            ref="searchForm"
            :model="searchForm"
            inline
            size="small"
            label-width="80px"
          >
            <el-form-item label="触发时间">
              <el-date-picker
                v-model="entryTime"
                type="daterange"
                start-placeholder="开始日期"
                range-separator="~"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                clearable
                :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="订单来源商家" label-width="120px">
              <el-select
                v-model="searchForm.createCompanyId"
                clearable
                filterable
                placeholder="请输入选择查询"
              >
                <el-option
                  v-for="item in companySelectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号" label-width="80px">
              <el-input
                v-model="searchForm.orderNo"
                placeholder="请输入订单号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="串号/序列号" label-width="95px">
              <el-input
                v-model="searchForm.imei"
                placeholder="请输入串号/序列号查询"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="触发原因" label-width="80px">
              <el-select
                v-model="searchForm.riskSource"
                clearable
                multiple
                placeholder="请输入选择查询"
              >
                <el-option label="平台风控" value="00"></el-option>
                <el-option label="上游风控" value="01"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                round
                :loading="searchLoading"
                @click="getTableData(1)"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="mb-10" style="display: flex;justify-content: flex-end;">
          <el-button
            type="success"
            size="small"
            :loading="exportLoading"
            @click="exportExcel"
            >导出Excel</el-button
          >
        </div>
      </div>
      <GlobalTable
        ref="GlobalTable"
        v-loading="searchLoading"
        :columns="tableColumns"
        :data="tableDataList"
        :currentPage="page.pageNum"
        :total="page.total"
        :pageSize="page.pageSize"
        @handleCurrentChange="getTableData"
      >
        <el-table-column label="触发订单号" slot="orderNo" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.orderNo" class="btn" @click="goDetails(row)">{{
              row.orderNo
            }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="触发原因" slot="riskSource" align="center">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.isPlatformRisk">{{ row.isPlatformRisk?'平台风控':'' }}</span>
              <span v-if="row.isPlatformRisk && row.isOutRisk">、</span>
              <span v-if="row.isOutRisk">{{ row.isOutRisk?'上游风控':'' }}</span>
            </div>
            <span class="btn" v-if="row.isOutRisk" @click="seeRiskSource(row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column label="询价门店" slot="createCompanyName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.createCompanyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="触发订单机型" slot="machineName" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.machineName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          slot="state"
          label="订单状态"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.state === '00'">待确认</span>
            <span v-else-if="row.state === '01'">已确认</span>
            <span v-else-if="row.state === '02'">待支付</span>
            <span v-else-if="row.state === '03'">已绑码</span>
            <span v-else-if="row.state === '04'">已收货</span>
            <span v-else-if="row.state === '05'">降价收货</span>
            <span v-else-if="row.state === '10'">已取消</span>
            <span v-else-if="row.state === '20'">已作废</span>
            <span v-else-if="row.state === '30'">已退回</span>
          </template>
        </el-table-column>
        <el-table-column label="订单最高报价" slot="maxQuotePrice" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.maxQuotePrice || "无报价" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="订单成交回收商"
          slot="manualMerchantName"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.manualMerchantName || "--" }}
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog
      title="上游风控信息"
      :visible.sync="riskValDiaShow"
      width="500px">
      <div style="padding-bottom: 50px;">
        <p class="mb-10" style="color: #333;font-size: 16px;">风控信息：</p>
        <p style="color: #ff8695;">{{currentRow.outRiskValue}}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";

export default {
  props: {
    companySelectList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      entryTime: [
        moment()
          .day(moment().day() - 6)
          .format("YYYY-MM-DD 00:00:00"),
        moment().format("YYYY-MM-DD 23:59:59"),
      ],
      pickerMinDate: null,
      pickerMaxDate: null,
      day30: 29 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day30 ||
              time.getTime() < this.pickerMinDate - this.day30
            );
          }
          return false;
        },
      },
      searchLoading: false,
      searchForm: {
        imei: "",
        orderNo: "",
        createCompanyId: "",
        riskSource: [],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataList: [],
      tableColumns: [
        { slotName: "orderNo" },
        { label: "风险串号/序列号", prop: "imei" },
        { slotName: "riskSource" },
        { slotName: "createCompanyName" },
        { slotName: "machineName" },
        { slotName: "state" },
        { slotName: "maxQuotePrice" },
        { slotName: "manualMerchantName" },
        { label: "触发时间", prop: "createTime" },
      ],
      exportLoading: false,
      currentRow: {},
      riskValDiaShow: false,
    };
  },
  created() {
    this.getTableData(1)
  },
  methods: {
    getTableData(pageNum) {
      if (pageNum) {
        this.page.pageNum = pageNum;
      }
      let startTime = "";
      let endTime = "";
      if (this.entryTime === null) {
        (startTime = ""), (endTime = "");
      } else {
        (startTime = moment(this.entryTime[0]).format("x")),
          (endTime = moment(this.entryTime[1]).format("x"));
      }
      const baseRequest = {
        ...this.searchForm,
        startTime,
        endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.searchLoading = true;
      _api
        .riskNumberRecordsList(baseRequest)
        .then((res) => {
          if (res.code === 1) {
            this.tableDataList = res.data.records;
            this.page.pageNum = res.data.current;
            this.page.total = res.data.total;
          }
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
    exportExcel() {
      let startTime = "";
      let endTime = "";
      if (this.entryTime === null) {
        (startTime = ""), (endTime = "");
      } else {
        (startTime = moment(this.entryTime[0]).format("x")),
          (endTime = moment(this.entryTime[1]).format("x"));
      }
      const baseRequest = {
        ...this.searchForm,
        startTime,
        endTime,
      };
      this.exportLoading = true;
      _api
        .riskNumberRecordsExport(baseRequest)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            //
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                this.$message.error(data.msg || "导出失败");
              }
            } catch (err) {
              const fileName = "风险串号触发记录.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 订单详情
    goDetails(row) {
      let routeData = this.$router.resolve({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
      window.open(routeData.href, "_blank");
    },
    // 查看风控
    seeRiskSource(row) {
      this.currentRow = row;
      this.riskValDiaShow = true;
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.flex {
  display: flex;
  align-items: center;
}
.red_txt {
  color: #ff687b;
  font-size: 14px;
}
.mt-10 {
  margin-top: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-20 {
  margin-right: 20px;
}
.btn {
  text-decoration: underline;
  cursor: pointer;
  color: #0981ff;
}
.nowrap-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
